/**
 * 缓存说明:虚拟设备缓存
 */
import vm from '@/cache/storeTools.js'
import powerApi from '@/components/api/powerApi.js'
import eventApi from '@/components/api/eventApi.js'
import meterReadingApi from '@/components/api/meterReading/meterReadingApi.js'
import recordApi from '@/components/api/money/recordApi.js'
import de from "element-ui/src/locale/lang/de";

var basestate = {
	// 当前公司信息
	nowUnit: {},
	nowUser: {},
	countInfo: {
		allMeter: '-',
		allWaterMeter: '-',
		arrearsMeter: '-',
		gj: '-',
		onlineMeter: '-',
		onlineWater: '-',
		owner: '-',
		unConfirmGj: '-',
		unConfirmYj: '-',
		yj: '-'
	}, // 小区概况
	menuTree: [{name:'计费管理',id:100,next:[{name:'单价计费',id:101},{name:'阶梯计费',id:102},{name:'费率计费',id:103}]},{name:'支付管理',id:200}],
	chargeModeList: [{text:'请选择',value:''},{text:'单价计费',value:'SingleBilling'},{text:'阶梯计费',value:'StepBilling'},{text:'费率计费',value:'PeakAndValleyBilling'}],
	eventCount: {},  // 事件总数
	unitAllEvent: {
		data: [],
		total: 0
	},  // 单位所有预警事件
	allEventTypes: {}, // 1 越界报警  2 变位报警  3 故障报警  4 用户操作事件  5 系统事件  6 SOE 事件  7 通讯信息
	pieEarlyWarning: {},  // 预警饼图数据
	countPayRecord: {}, // 支付方式记录
	meterReadingList: [],
	payRecords: [], // 支付记录列表
	deviceNos: '',  // 用于查询充值记录
	powerDataList: [],  // 柱状图耗能数组
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getPieEarlyWarning(state, getters) {
			if(isempty(state.eventCount) || isempty(state.allEventTypes)){
				return {}
			}
			var keys = Object.keys(state.eventCount)
			var list = []
			for(let i = 0;i < keys.length;i++){
				if(['1','2','3'].indexOf(keys[i]) < 0){
					continue
				}
				list.push({
					name: state.allEventTypes[keys[i]],
					value: state.eventCount[keys[i]],
					labelLine: {
						length: 10,
						length2: 10
					}
				})
			}
			return {
				series: [{
					name: '预警概况',
					type: 'pie',
					radius: '60%',
					center: ['50%', '45%'],
					data: list,
					itemStyle: {
						emphasis: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
				}
				}]
			}
		},
		getPiePaymentRate(state, getters) {
			var keys = Object.keys(state.countPayRecord)
			var list = []
			for(let i = 0;i < keys.length;i++){
				switch (keys[i]) {
					case 'Recharge_AliPay':
						var name = '支付宝'
						break
					case 'Recharge_CashPay':
						var name = '现金支付'
						break
					case 'Recharge_UnionPay':
						var name = '银行卡'
						break
					case 'Recharge_WeixinPay':
						var name = '微信'
						break
				}
				list.push({
						name: name,
						value: parseFloat(state.countPayRecord[keys[i]]) / 100,
						labelLine: {
							length: 10,
							length2: 10
						}
					})
			}
			return {
				series: [{
					name: '设备缴费比率',
					type: 'pie',
					radius: '60%',
					minAngle: 15,
					center: ['50%', '45%'],
					data: list,
					itemStyle: {
						emphasis: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			}
		},
		getCountPayRecord(state, getters) {
			if(isempty(state.countPayRecord)){
				store.commit('getCountPayRecord')
				return {}
			}
			return state.countPayRecord
		},
		getPowerDataList(state, getters) {
			if(isempty(state.powerDataList)){
				store.commit('getPowerDataList')
				return []
			}
			return state.powerDataList
		},
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		setNowUser(state, user) {
			if(user == undefined){
				return
			}
			vm.Vue.set(state, 'nowUser', user)
		},
		setNowUnit(state, unit) {
			if(unit == undefined){
				return
			}
			vm.Vue.set(state, 'nowUnit', unit)
			store.commit('getKanbanCountInfo', unit.id)
			store.commit('getDeviceCount', unit.id)
			store.commit('getCountPayRecord', unit.id)//缴费设备比例
			store.commit('getPayRecords', unit.id)//实时缴费信息
		},
		// 获取看板数据
		getKanbanCountInfo(state, unitId) {
			vm.Vue.set(state, 'countInfo', {
				allMeter: '-',
				allWaterMeter: '-',
				arrearsMeter: '-',
				gj: '-',
				onlineMeter: '-',
				onlineWater: '-',
				owner: '-',
				unConfirmGj: '-',
				unConfirmYj: '-',
				yj: '-'
			})
			meterReadingApi.getKanbanCountInfo(unitId, respon => {
				vm.Vue.set(state, 'countInfo', respon)
			})
		},
		// 获取单位下所有的抄表列表
		getDeviceCount(state, id) {
			meterReadingApi.getMeterReadingConfigListByUnitId(id, respon => {
				vm.Vue.set(state, 'meterReadingList', [])
				if(isempty(respon)){
					return
				}
				vm.Vue.set(state, 'meterReadingList', respon)
				var deviceNos = []
				for(let i = 0;i < respon.length;i++){
					deviceNos.push(respon[i].deviceNo)
				}
				//console.info("devices:"+JSON.stringify(deviceNos));
				vm.Vue.set(state, 'deviceNos', deviceNos)
				store.commit('getCountPayRecord', deviceNos.join(','))
				store.commit('getPayRecords', deviceNos.join(','))
				store.commit('getCountAllEvents', deviceNos.join(','))
				store.commit('getUnitAllEvent', deviceNos.join(','))
			})
		},
		setAllEventTypes(state, allEventTypeList) {
			var allEventTypes = {}
			for(let i = 0;i < allEventTypeList.length;i++) {
				allEventTypes[allEventTypeList[i].id] = allEventTypeList[i].name
			}
			vm.Vue.set(state, 'allEventTypes', allEventTypes)
		},
		getCountAllEvents(state, deviceIds) {
			eventApi.countEventListByUser(state.nowUser.id, state.nowUnit.id, undefined, -1, undefined, deviceIds, undefined, undefined, '', respon => {
				vm.Vue.set(state, 'eventCount', respon)
			})
		},
		// 获取单位事件信息
		getUnitAllEvent(state, deviceIds) {
			if(isempty(state.nowUser)){
				return
			}
			vm.Vue.set(state, 'unitAllEvent', {data:[],total:0})
			var today = new Date()
			var year = today.getFullYear()
			var month = today.getMonth()
			var todayTime = today.getTime()
			eventApi.searchEventListByUser(state.nowUser.id, state.nowUnit.id, '', -1, '', deviceIds, new Date(year, month, 1).getTime(),
				todayTime, 1, 100, '',
				respon => {
					vm.Vue.set(state, 'unitAllEvent', respon)
				})
		},
		getCountPayRecord(state, targetIds) {
			//debugger
			vm.Vue.set(state, 'countPayRecord', {})
			if(targetIds == '' || targetIds == undefined){
				return
			}
			var year = new Date().getFullYear()
			recordApi.countPayRecord(targetIds, 'MeterReading', new Date(year+'/1/1 00:00:00').getTime(), new Date().getTime(), respon => {
				vm.Vue.set(state, 'countPayRecord', respon)
			})
		},
		getPayRecords(state, targetIds) {
			//debugger
			vm.Vue.set(state, 'payRecords', {dataList:[],total:0})
			if(targetIds == ''){
				return
			}
			recordApi.searchRecordLimit(targetIds, 'MeterReading', 0, 100, undefined, undefined, undefined, respon => {
				vm.Vue.set(state, 'payRecords', respon)
			})
		},
		getPowerDataList(state) {
			if(isempty(state.nowUnit)){
				return
			}
			vm.Vue.set(state, 'powerDataList', [])
			var id = state.nowUnit.id
			powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), id, respon => {
				if (id == state.nowUnit.id) { //接口延迟时 只赋值当前的unit结果
					vm.Vue.set(state, 'powerDataList', respon)
				}
			})
		},
	}
});

//对外提供
export default store